module.exports = __webpack_public_path__ + "static/6h-honest-3e8f154108c8e09c048f65cd6b60891f.png";